import fr from "./fr.json";
import en from "./en.json";
import expedilock from "./expedilock";

const translations = { fr, en, expedilock };

export default translations;
